module.exports = __webpack_public_path__ + "img/Instagram_logo@2x.e1cf8593.png";